<app-query-builder *ngIf="viewMode() === 'query'" [viewMode]="viewMode" [setView]="setView">
</app-query-builder>

<app-social-ai-reports-chart *ngIf="viewMode() === 'metrics'" [viewMode]="viewMode" (goQuery)="viewMode.set('query')"
  (goMetrics)="viewMode.set('metrics')">
</app-social-ai-reports-chart>